import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { Seo } from "@/components/Seo";
import { CONTACT, STEPS } from "@/content/site";
import { trackLeadConversion } from "@/lib/analytics";

export default function ThankYou() {
  const { state } = useLocation();
  const submitted = !!state?.submitted;
  useEffect(() => { if (submitted) trackLeadConversion(); }, [submitted]);

  return (
    <>
      <Seo path="/thank-you" />
      <section className="section bg-ivory" data-testid="thank-you-page">
        <div className="wrap max-w-3xl">
          <p className="eyebrow mb-5">Inquiry Received</p>
          <h1 className="text-4xl font-bold sm:text-5xl lg:text-6xl">Thank You for Your Interest in VidaVital Medical</h1>
          <p className="lede mt-6">We’ve received your franchise inquiry and will reach out to provide more information.</p>

          <h2 className="mt-14 text-2xl font-semibold">What Happens Next</h2>
          <ol className="mt-6 space-y-px bg-line" data-testid="thank-you-next-steps">
            {STEPS.slice(1, 4).map((s, i) => (
              <li key={s.title} className="bg-white p-6">
                <p className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-gold-deep">Step {i + 2}</p>
                <h3 className="mt-2 text-lg font-semibold">{s.title}</h3>
                <p className="mt-2 text-stone-600">{s.text}</p>
              </li>
            ))}
          </ol>

          <h2 className="mt-14 text-2xl font-semibold">Prefer to Talk Now?</h2>
          <p className="mt-3 text-stone-600">Franchise Development Contact: {CONTACT.person}</p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <a href={CONTACT.tel} data-loc="thank-you" className="btn-gold" data-testid="thank-you-call"><Phone aria-hidden="true" className="h-4 w-4" />Call {CONTACT.phone}</a>
            <a href={CONTACT.mailto} data-loc="thank-you" className="btn-line" data-testid="thank-you-email"><Mail aria-hidden="true" className="h-4 w-4" />Email Us</a>
          </div>
          <Link to="/opportunity" className="text-link mt-10 inline-block" data-testid="thank-you-opportunity-link">Keep exploring the franchise opportunity</Link>
        </div>
      </section>
    </>
  );
}
